module.exports = __webpack_public_path__ + "static/media/How_to_Create_an_IRS_Account.0710d13a.pdf";